
































import {
	computed,
	defineComponent,
	ref,
	watch,
} from '@vue/composition-api';
import LoaderState from '@front-app/components/LoaderState.vue';
import LoginForm from '@front-app/components/forms/LoginForm.vue';
import PublicAuthPage from '@front-app/components/layouts/PublicAuthPage.vue';
import PublicEventCard from '@front-app/components/cards/PublicEventCard.vue';
import SimpleCard from '@front-app/components/cards/SimpleCard.vue';
import { BannerLocation } from '@front-app/services/ActionApi/ActionModel';
import { getPublicEventById } from '@front-app/services/EventsApi/EventsApi';
import { getPublicGroup } from '@front-app/services/GroupsApi/GroupsApi';
import { PublicEventData } from '@front-app/services/EventsApi/EventModel';
import { PublicEventsBannerStore } from '@front-app/store/singletons/Events';
import { PublicGroupData } from '@front-app/services/GroupsApi/GroupModel';
import { Routes } from '@front-app/constants/routes';
import { Spacing } from '@front-app/components/constants';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';

export default defineComponent({
	components: {
		LoaderState,
		LoginForm,
		PublicAuthPage,
		PublicEventCard,
		SimpleCard,
	},
	props: {
		eventId: {
			type: String,
			required: true,
		},
		groupId: {
			type: String,
			default: '',
		},
	},
	setup(props, ctx) {
		// Event preview
		const event = ref(null as null | PublicEventData);
		const group = ref(null as null | PublicGroupData);

		const {
			track: trackFetchingPublicEvent,
			isLoading: isFetchingPublicEvent,
			isSuccess: isSuccessFetchingPublicEvent,
		} = useAsyncStatus();
		const {
			track: trackFetchingPublicEventBanner,
			isLoading: isFetchingPublicEventBanner,
		} = useAsyncStatus();
		watch(() => props.eventId, async (currentEventId) => {
			await trackFetchingPublicEventBanner(PublicEventsBannerStore.fetch(currentEventId));
			const result = await trackFetchingPublicEvent(getPublicEventById(currentEventId));
			if (isSuccessFetchingPublicEvent) {
				event.value = result;
			}
		}, { immediate: true });

		const {
			track: trackFetchingPublicGroup,
			isLoading: isFetchingPublicGroup,
			isSuccess: isSuccessFetchingPublicGroup,
		} = useAsyncStatus();
		watch(() => props.groupId, async (currentGroupId) => {
			if (!currentGroupId) {
				return;
			}
			const result = await trackFetchingPublicGroup(getPublicGroup(currentGroupId));
			if (isSuccessFetchingPublicGroup) {
				group.value = result;
			}
		}, { immediate: true });

		const isEventPublic = computed(() => event.value && event.value.isPublic);
		// END Event preview

		// Logging in
		const redirect = () => {
			if (props.groupId) {
				ctx.root.$router.push({
					name: Routes.GROUP_EVENT,
					params: { eventId: props.eventId, groupId: props.groupId },
				});
			} else {
				ctx.root.$router.push({
					name: Routes.EVENT,
					params: { eventId: props.eventId },
				});
			}
		};
		// END Logging in

		return {
			// Event preview
			BannerLocation,
			isFetchingPublicEvent,
			isFetchingPublicEventBanner,
			isFetchingPublicGroup,
			isEventPublic,
			event,
			group,
			// Logging in
			redirect,
			// Util
			Spacing,
		};
	},
});
